export enum COMPANY_CHOICE {
  COMPANIES_PW = 'gesellschaften',
}
